import { Toast } from 'vant';
import store from './store'
import router from './router'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css' 
import { mapGetters } from 'vuex'
// 路由白名单
const whiteList = ['Pay','404','401','Protocol','Bind','Login']

router.beforeEach((to, from, next) => {
    if (to.meta.title) document.title = to.meta.title
    next()
})

// token及白名单校验
function permissionRouter(token = null, to, from, user) {

    // 没有匹配路由
    if (to.matched.length === 0 && !whiteList.includes(to.path)) {
        return '404'    
    }
    if (token) {
        store.commit('SET_TOKEN', token)
        return false
    } else {
        if (!whiteList.includes(to.name)) {
            return '401'
        } else {
            return false
        }
    }
}

router.afterEach(() => {
    Toast.clear()
    // NProgress.done()
})